"use client";

import RadialOrbitalTimeline from "@/components/ui/radial-orbital-timeline";
import type { AppCopy, Direction } from "@/lib/i18n";

interface RadialOrbitalTimelineDemoProps {
  copy: AppCopy["timeline"];
  direction: Direction;
}

export function RadialOrbitalTimelineDemo({
  copy,
  direction,
}: RadialOrbitalTimelineDemoProps) {
  return (
    <RadialOrbitalTimeline
      copy={copy}
      direction={direction}
      timelineData={copy.items}
    />
  );
}

export default {
  RadialOrbitalTimelineDemo,
};
